export class LoaderState {
  constructor(public id: string, public active: boolean = false) {}
}
